import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import CategorySelection from "./CategorySelection";

function NewsCategorySelector(props) {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      Scrivito.load(() =>
        Scrivito.Obj.onAllSites()
          .where("_objClass", "equals", "GlobalConfigPage")
          .take(1)
      ).then((objs) => {
        const [obj] = objs;
        if (obj) {
          const categoryConfigWidget = obj
            .get("body")
            .find((item) => item.objClass() === "NewsCategoryConfigWidget");
          const categoriesMap = categoryConfigWidget
            .get("body")
            .map((item) => ({
              key: item.get("key"),
              de: item.get("de"),
              en: item.get("en"),
            }));
          setCategories(categoriesMap);
        } else {
          setError("no_config_page_found");
        }
        setLoading(false);
      });
    };
    fetchCategories();
  }, []);

  return (
    <div className="scrivito_detail_content">
      {loading && <div>LOADING ...</div>}
      {error && (
        <div>
          Configuration was not found. Please ask you administrator for help.
        </div>
      )}
      <CategorySelection categories={categories} {...props} />
    </div>
  );
}

export default Scrivito.connect(NewsCategorySelector);
